import * as React from 'react'
import { NavLink } from 'react-router-dom'

import { brand } from '@/brand/brand'
import { cn } from '@/lib/utils'

interface NavItem {
  to: string
  label: string
}

interface NavGroup {
  section: string
  items: NavItem[]
}

const DOCS_NAV: NavGroup[] = [
  {
    section: 'Getting Started',
    items: [
      { to: '/docs', label: 'Overview' },
    ],
  },
  {
    section: 'Workflows',
    items: [
      { to: '/docs/create-ad', label: 'Create Ad' },
      { to: '/docs/create-image', label: 'Create Image' },
    ],
  },
  {
    section: 'Management',
    items: [
      { to: '/docs/products', label: 'Products' },
      { to: '/docs/assets', label: 'Asset Library' },
      { to: '/docs/jobs', label: 'Jobs' },
    ],
  },
]

export function DocsSidebar() {
  return (
    <nav aria-label="Docs navigation">
      <p className="text-xs tracking-wider text-muted-foreground uppercase px-3 mb-1">Docs</p>
      <p className="text-base font-semibold text-foreground px-3 mb-4">{brand.productName} Handbook</p>

      {DOCS_NAV.map(({ section, items }) => (
        <div key={section}>
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground/70 mt-6 mb-2 px-3">
            {section}
          </p>
          {items.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/docs'}
              className={({ isActive }) =>
                cn(
                  'block rounded-md px-3 py-1.5 text-sm transition-colors',
                  isActive
                    ? 'border-l-2 border-foreground bg-accent/50 text-foreground font-medium'
                    : 'text-muted-foreground hover:text-foreground hover:bg-accent/30',
                )
              }
            >
              {label}
            </NavLink>
          ))}
        </div>
      ))}
    </nav>
  )
}
